import { Dispatch } from 'react';
import { isNil } from 'ramda';
import { isEmptyArray } from 'ramda-adjunct';
import { Nullish } from 'shared/web';
type UseChoiceFilterProps = {
  model: string[] | string | Nullish;
  onChange: (value: string[] | string | Nullish) => void;
};
export const useChoiceFilter = (props: UseChoiceFilterProps): [string[] | string, Dispatch<string[] | string | Nullish>] => {
  const setModel = (valuesToSet: string[] | string | Nullish) => {
    const newModel = isEmptyArray(valuesToSet) || isNil(valuesToSet) ? null : valuesToSet;
    props.onChange(newModel);
  };
  return [props.model ?? [], setModel];
};